import { Helmet } from 'react-helmet-async';

const BASE_URL = 'https://creofarm.org';
const DEFAULT_IMAGE = `${BASE_URL}/og-image.png`;

const PAGE_META = {
  home: {
    en: { title: 'Creo Farm — Premium 3D Figurines & Custom Collectibles', description: 'Handcrafted 3D figurines made from your photos. Custom figurines for couples, families, pets. Premium quality, worldwide shipping.' },
    de: { title: 'Creo Farm — Premium 3D-Figuren & individuelle Sammlerstücke', description: 'Handgefertigte 3D-Figuren nach Ihren Fotos. Individuelle Figuren für Paare, Familien, Haustiere. Premium-Qualität, weltweiter Versand.' },
    ua: { title: 'Creo Farm — Преміум 3D-фігурки та індивідуальні колекційні предмети', description: 'Фігурки ручної роботи за вашими фото. Індивідуальні фігурки для пар, сімей, домашніх тварин. Преміум якість, доставка по всьому світу.' },
  },
  catalog: {
    en: { title: 'Collection — Creo Farm', description: 'Browse our curated selection of handcrafted 3D collectible figurines. Limited editions and premium pieces.' },
    de: { title: 'Kollektion — Creo Farm', description: 'Entdecken Sie unsere handgefertigten 3D-Sammelfiguren. Limitierte Auflagen und Premium-Stücke.' },
    ua: { title: 'Колекція — Creo Farm', description: 'Перегляньте нашу добірку колекційних 3D-фігурок ручної роботи. Лімітовані серії та преміум предмети.' },
  },
  customOrder: {
    en: { title: 'Custom Figurine — Turn Your Photos into 3D Art | Creo Farm', description: 'Upload your photos and we create a unique 3D figurine. Perfect gift for couples, weddings, families. From 49 EUR.' },
    de: { title: 'Individuelle Figur — Ihre Fotos als 3D-Kunst | Creo Farm', description: 'Laden Sie Ihre Fotos hoch, wir erstellen eine einzigartige 3D-Figur. Perfektes Geschenk für Paare, Hochzeiten, Familien. Ab 49 EUR.' },
    ua: { title: 'Індивідуальна фігурка — Ваші фото як 3D-мистецтво | Creo Farm', description: 'Завантажте фото, і ми створимо унікальну 3D-фігурку. Ідеальний подарунок для пар, весіль, сімей. Від 49 EUR.' },
  },
};

export default function SEO({ page = 'home', lang = 'en', title, description, image, path = '' }) {
  const meta = PAGE_META[page]?.[lang] || PAGE_META[page]?.en || {};
  const pageTitle = title || meta.title || 'Creo Farm';
  const pageDesc = description || meta.description || '';
  const pageImage = image || DEFAULT_IMAGE;
  const canonical = `${BASE_URL}${path}`;

  return (
    <Helmet>
      <title>{pageTitle}</title>
      <meta name="description" content={pageDesc} />
      <link rel="canonical" href={canonical} />
      <meta property="og:title" content={pageTitle} />
      <meta property="og:description" content={pageDesc} />
      <meta property="og:image" content={pageImage} />
      <meta property="og:url" content={canonical} />
      <meta property="og:type" content="website" />
      <meta property="og:site_name" content="Creo Farm" />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={pageTitle} />
      <meta name="twitter:description" content={pageDesc} />
      <meta name="twitter:image" content={pageImage} />
      <html lang={lang === 'ua' ? 'uk' : lang} />
    </Helmet>
  );
}
